import PropTypes from 'prop-types';
import CreateFormWizard from './CreateFormWizard';

const CreateForm = ({onClose}) => <CreateFormWizard onClose={onClose}/>;

CreateForm.propTypes = {
    onClose: PropTypes.func,
};

export default CreateForm;
